import { FaFileImport, FaFileExport, FaThLarge, FaList } from "react-icons/fa";
import { IoIosAdd } from "react-icons/io";
import { FiTrash2 } from "react-icons/fi";
import CustomSelect from "../../../Common/CustomSelect";
import "./GlobalLibraryToolbar.css";

const GlobalLibraryToolbar = ({
    search,
    setSearch,
    groupBy,
    setGroupBy,
    view,
    setView,
    isOwner,
    selectedCount,
    totalSelectableCount, // NEW
    allSelected,          // NEW
    onToggleSelectAll,    // NEW
    onAdd,
    onImport,
    onExport,
    onDeleteSelected,
    onImportSelected,
}) => {
    return (
        <div className="gl-toolbar">
            <div className="gl-toolbar-left">
                {isOwner && (
                    <button className="toolbar-buttons" onClick={onAdd}>
                        <span><IoIosAdd /></span> Add Article
                    </button>
                )}

                {isOwner && (
                    <button className="toolbar-buttons btn-import" onClick={onImport}>
                        <FaFileImport /> Import
                    </button>
                )}

                {isOwner && (
                    <button className="toolbar-buttons btn-export" onClick={onExport}>
                        <FaFileExport /> Export
                    </button>
                )}

                <label className="select-all-label">
                    <input
                        type="checkbox"
                        checked={allSelected}
                        disabled={!totalSelectableCount}
                        onChange={(e) => onToggleSelectAll?.(e.target.checked)}
                    />
                    Select All
                </label>

                {isOwner ? (
                    <button
                        className="btn-delete-all"
                        disabled={!selectedCount}
                        onClick={onDeleteSelected}
                    >
                        <FiTrash2 /> Delete ({selectedCount})
                    </button>
                ) : (
                    <button
                        className="btn-import-all"
                        disabled={!selectedCount}
                        onClick={onImportSelected}
                    >
                        <FaFileImport /> Import ({selectedCount})
                    </button>
                )}
            </div>

            <div className="gl-toolbar-center">
                <input
                    type="search"
                    placeholder="Search global library..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="article-search"
                />
            </div>

            <div className="gl-toolbar-right">
                <div className="gl-view-toggle">
                    <button
                        className={`gl-view-btn ${view === "catalog" ? "active" : ""}`}
                        onClick={() => setView("catalog")}
                        title="Catalog view"
                    >
                        <FaThLarge />
                    </button>
                    <button
                        className={`gl-view-btn ${view === "list" ? "active" : ""}`}
                        onClick={() => setView("list")}
                        title="List view"
                    >
                        <FaList />
                    </button>
                </div>

                {view === "list" && (
                    <>
                        <label>Group By</label>
                        <CustomSelect
                            value={groupBy}
                            onChange={(val) => setGroupBy(val)}
                            options={[
                                { value: "manufacturer", label: "Manufacturer" },
                                { value: "type", label: "Type" },
                                { value: "recordType", label: "Record Type" },
                                { value: "name", label: "Product group" },
                            ]}
                            menuWidth={160}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default GlobalLibraryToolbar;